export const ACTIVE_CONTENT_GROUP_TAB_URL_SEARCH_KEY_PREFIX =
  'activeContentGroupTab';

export function getActiveContentGroupTabUrlSearchKey(group: string) {
  return `${ACTIVE_CONTENT_GROUP_TAB_URL_SEARCH_KEY_PREFIX}-${group}`;
}
